import { Component, Input } from '@angular/core';

@Component({
  selector: 'studio-sidebar-group',
  templateUrl: './sidebar-group.component.html',
  styleUrls: ['./sidebar-group.component.scss'],
})
export class SidebarGroupComponent {
  @Input() heading: string;
}
